import React from "react";
import { Box, Inscription } from "@common-fe/common-fe";

interface Props {
  title: string;
  testId?:string;
  isBold?: boolean;
  isRequired?: boolean;
}

export const RequiredLabel: React.FC<Props> = ({
  title,
  testId,
  isBold,
  isRequired = true,
}) => (
  <Box direction="row" data-testid={testId}>
    {isRequired ? (
      <Inscription
        color="danger"
        margin={{
          right: '3px',
          top: '1px',
        }}
        data-testid={testId ? `${testId}_asterisk` : undefined}
      >
        *
      </Inscription>
    ) : null}
    <Inscription
      data-testid={testId ? `${testId}_title` : undefined}
      weight={isBold ? 'bold' : 'normal'}
    >
      {title}
    </Inscription>
  </Box>
);